<div class="simple-card">
  <page-title></page-title>
</div>

<div class="simple-card m-t-20">
  @if ({
    requestsReq: requestsReq$ | async,
    }; as content) {
    @if (!content.requestsReq?.isPristine) {
      @if (!content.requestsReq?.isLoading) {
        @if (!content.requestsReq?.hasError) {
          @if (content.requestsReq?.requests?.length) {
            <table-pro [configs]="tableConfig">
              <table class="table-responsive table-md">
                <thead>
                  <tr>
                    <th class="cx-col-type">{{ 'approvalspage.table.header.type' | cxTranslate }}</th>
                    <th class="cx-col-user">{{ 'approvalspage.table.header.user' | cxTranslate }}</th>
                    <th class="cx-col-date">{{ 'approvalspage.table.header.date' | cxTranslate }}</th>
                    <th class="cx-col-status">{{ 'approvalspage.table.header.status' | cxTranslate }}</th>
                    <th class="cx-col-actions">{{ 'approvalspage.table.header.actions' | cxTranslate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (request of content.requestsReq?.requests; track request) {
                    <tr [attr.data-code]="request.code">
                      <td class="cx-col-type" [attr.data-value]="request.type">
                        <span class="responsive-title">{{ 'approvalspage.table.header.type' | cxTranslate }}:</span>
                        {{ request.type }}
                      </td>
                      <td class="cx-col-user" [attr.data-value]="request.user">
                        <span class="responsive-title">{{ 'approvalspage.table.header.user' | cxTranslate }}:</span>
                        {{ request.user }}
                      </td>
                      <td class="cx-col-date" [attr.data-value]="request.date">
                        <span class="responsive-title">{{ 'approvalspage.table.header.date' | cxTranslate }}:</span>
                        {{ request.date | cxDate: 'MM/dd/yyyy' }}
                      </td>
                      <td class="cx-col-status" [attr.data-value]="request.status">
                        <span class="responsive-title">{{ 'approvalspage.table.header.status' | cxTranslate }}:</span>
                        {{ request.status }}
                      </td>
                      <td class="cx-col-actions">
                        <button type="button" class="btn btn-primary w-100 btn-sm" (click)="handlerOpenDetails(request)">
                          <span class="material-symbols-outlined d-flex m-r-4"> quick_reference_all </span>
                          {{ 'approvalspage.checkDetails' | cxTranslate }}
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </table-pro>
          } @else {
            <p class="text-center ff-bold m-0">{{ 'approvalspage.noContent' | cxTranslate }}</p>
          }
        } @else {
          <alert [alert]="alertMessage">{{ 'approvalspage.error' | cxTranslate }}</alert>
        }
      } @else {
        <local-loader></local-loader>
      }
    }
  }



</div>